export enum NotificationsQueryKeys {
  GET_ALL_NOTIFICATIONS = 'GET_ALL_NOTIFICATIONS',
  GET_MEMBER_NOTIFICATIONS_SETTINGS = 'GET_MEMBER_NOTIFICATIONS_SETTINGS',
}
